var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "EA361EAF-1D87-4DB4-9B20-3D2398C88207") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Onboarding",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Facilities",
    transform: "translate(-470.000000, -137.000000)",
    fill: "#2E384D"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Search-Bar",
    transform: "translate(444.000000, 128.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(26.000000, 7.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16,16.8688 L14.8688,18 L10.3432,13.4744 L11.4744,12.3432 L16,16.8688 Z M5.6,11.6 C3.3944,11.6 1.6,9.8056 1.6,7.6 C1.6,5.3944 3.3944,3.6 5.6,3.6 C7.8056,3.6 9.6,5.3944 9.6,7.6 C9.6,9.8056 7.8056,11.6 5.6,11.6 L5.6,11.6 Z M5.6,2 C2.5072,2 0,4.5072 0,7.6 C0,10.6928 2.5072,13.2 5.6,13.2 C8.6928,13.2 11.2,10.6928 11.2,7.6 C11.2,4.5072 8.6928,2 5.6,2 L5.6,2 Z",
    id: "search_left-[#1506]"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchLeft);
export default __webpack_public_path__ + "static/media/search-left.c1f54fd986ba42a4bc9c06b110332a55.svg";
export { ForwardRef as ReactComponent };